import { render, staticRenderFns } from "./Ongkir.vue?vue&type=template&id=5af59719&scoped=true"
import script from "./Ongkir.vue?vue&type=script&lang=js"
export * from "./Ongkir.vue?vue&type=script&lang=js"
import style0 from "../assets/login.css?vue&type=style&index=0&id=5af59719&prod&scoped=true&lang=css&external"
import style1 from "./Ongkir.vue?vue&type=style&index=1&id=5af59719&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af59719",
  null
  
)

export default component.exports